/* ==========================================================
   uhren4you – Produktseite: kleine Verbesserungen
   1. Bild-Pfeile: springen immer genau ein ganzes Bild weiter, am letzten Bild ist Schluss;
      die passende Miniatur wird mit markiert
   2. Lieferhinweis: Versandtag (heute / morgen / Montag / Datum) + Aktualisierung bei Variantenwechsel
      (Markup: snippets/u4y-delivery.liquid). Usability v2 (31.10.2026): Feiertage werden berücksichtigt
      (Versand: bundesweit + Niedersachsen, Lieferung: bundesweit), bei Lieferland Deutschland zusätzlich
      das voraussichtliche Lieferdatum (Zustellung Mo–Sa am Werktag nach dem Versand).
   3. Farbvarianten (App "mpg-swatch"): bei vielen Varianten nur die ersten zeigen, Rest aufklappbar
   4. "Fragen zum Produkt" (App "prorw"): englische Reste übersetzen
   5. Geschenkverpackung: "kostenlos" statt "+0,00 €"
   6. Kaufleiste unten: erscheint, sobald der Warenkorb-Knopf aus dem Bild gescrollt ist
   Texte: window.u4yPdpText (snippets/u4y-gallery-assets.liquid → snippets/u4y-tp.liquid)
   ========================================================== */
(function () {
  'use strict';
  if (window.u4yPdpLoaded) return;
  window.u4yPdpLoaded = true;

  var T = window.u4yPdpText || {};
  var LANG = (document.documentElement.lang || 'de').slice(0, 2);

  /* ---------------- 1. Bild-Pfeile + Miniaturen ---------------- */
  function viewerList(slider) {
    return slider.querySelector('.product__media-list') || slider.querySelector('ul');
  }
  function visibleItems(list) {
    return Array.prototype.filter.call(list.children, function (li) {
      return li.offsetParent !== null && li.offsetWidth > 0;
    });
  }
  function currentIndex(list, items) {
    var pad = parseFloat(getComputedStyle(list).scrollPaddingLeft) || 0;
    var best = 0;
    var dist = Infinity;
    items.forEach(function (li, i) {
      var d = Math.abs(li.offsetLeft - pad - list.scrollLeft);
      if (d < dist) {
        dist = d;
        best = i;
      }
    });
    return best;
  }
  function isHorizontal(items) {
    return items.length > 1 && items[1].offsetTop === items[0].offsetTop && items[1].offsetLeft !== items[0].offsetLeft;
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('slider-component[id^="GalleryViewer"] .slider-button');
      if (!btn) return;
      var slider = btn.closest('slider-component');
      var list = viewerList(slider);
      if (!list) return;
      var items = visibleItems(list);
      if (!isHorizontal(items)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var next = btn.classList.contains('slider-button--next') || btn.getAttribute('name') === 'next';
      var target = Math.min(Math.max(currentIndex(list, items) + (next ? 1 : -1), 0), items.length - 1);
      var pad = parseFloat(getComputedStyle(list).scrollPaddingLeft) || 0;
      var max = list.scrollWidth - list.clientWidth;
      list.scrollTo({ left: Math.min(Math.max(items[target].offsetLeft - pad, 0), max), behavior: 'smooth' });
    },
    true
  );

  function syncThumbs(slider) {
    var list = viewerList(slider);
    if (!list) return;
    var items = visibleItems(list);
    if (!isHorizontal(items)) return;
    var active = items[currentIndex(list, items)];
    var gallery = slider.closest('media-gallery');
    if (!active || !gallery) return;
    var thumbList = gallery.querySelector('.thumbnail-list');
    if (!thumbList) return;
    var li = thumbList.querySelector('[data-target="' + active.dataset.mediaId + '"]');
    if (!li) return;
    var btn = li.querySelector('.thumbnail');
    if (!btn || btn.getAttribute('aria-current') === 'true') return;
    thumbList.querySelectorAll('.thumbnail[aria-current]').forEach(function (b) {
      b.removeAttribute('aria-current');
    });
    btn.setAttribute('aria-current', 'true');
    var scroller = li.closest('.slider') || thumbList;
    var l = li.offsetLeft;
    if (l < scroller.scrollLeft || l + li.offsetWidth > scroller.scrollLeft + scroller.clientWidth) {
      scroller.scrollTo({ left: l - scroller.clientWidth / 2 + li.offsetWidth / 2, behavior: 'smooth' });
    }
  }
  function bindThumbSync() {
    document.querySelectorAll('slider-component[id^="GalleryViewer"]').forEach(function (slider) {
      if (slider.dataset.u4yThumbs) return;
      var list = viewerList(slider);
      if (!list) return;
      slider.dataset.u4yThumbs = '1';
      var t;
      list.addEventListener(
        'scroll',
        function () {
          clearTimeout(t);
          t = setTimeout(function () {
            syncThumbs(slider);
          }, 120);
        },
        { passive: true }
      );
    });
  }

  /* ---------------- 2. Lieferhinweis ---------------- */
  // Feiertage: bundesweit; für den Versandtag zusätzlich Niedersachsen (Reformationstag), Versand aus Hagen a. T. W.
  var holidayCache = {};
  function dayKey(d) {
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }
  function addDays(d, n) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
  }
  function easterSunday(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var n = h + l - 7 * m + 114;
    return new Date(y, Math.floor(n / 31) - 1, (n % 31) + 1);
  }
  function holidays(y) {
    if (!holidayCache[y]) {
      var es = easterSunday(y);
      var all = [y + '-1-1', y + '-5-1', y + '-10-3', y + '-12-25', y + '-12-26'];
      [-2, 1, 39, 50].forEach(function (n) {
        all.push(dayKey(addDays(es, n))); // Karfreitag, Ostermontag, Christi Himmelfahrt, Pfingstmontag
      });
      holidayCache[y] = { de: all, ship: all.concat([y + '-10-31']) };
    }
    return holidayCache[y];
  }
  function isShipDay(d) {
    var w = d.getDay();
    return w >= 1 && w <= 5 && holidays(d.getFullYear()).ship.indexOf(dayKey(d)) === -1;
  }
  function isDeliveryDay(d) {
    return d.getDay() !== 0 && holidays(d.getFullYear()).de.indexOf(dayKey(d)) === -1;
  }
  function berlinNow() {
    try {
      return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
    } catch (err) {
      return new Date();
    }
  }
  var DATE_LOCALE = { de: 'de-DE', en: 'en-GB', fr: 'fr-FR', es: 'es-ES', it: 'it-IT', sv: 'sv-SE', pl: 'pl-PL', nl: 'nl-NL' };
  function shortDate(d) {
    try {
      return new Intl.DateTimeFormat(DATE_LOCALE[LANG] || 'de-DE', { weekday: 'short', day: 'numeric', month: 'numeric' }).format(d);
    } catch (err) {
      return d.getDate() + '.' + (d.getMonth() + 1) + '.';
    }
  }
  function shipText() {
    var now = berlinNow();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var ship = today;
    if (!(isShipDay(today) && now.getHours() < 14)) {
      do {
        ship = addDays(ship, 1);
      } while (!isShipDay(ship));
    }
    var diff = Math.round((ship - today) / 864e5);
    var deliv = ship;
    do {
      deliv = addDays(deliv, 1);
    } while (!isDeliveryDay(deliv));

    document.querySelectorAll('[data-u4y-ship]').forEach(function (el) {
      var msg;
      if (diff === 0) msg = el.dataset.today;
      else if (diff === 1) msg = el.dataset.tomorrow;
      else if (ship.getDay() === 1 && diff <= 3) msg = el.dataset.monday;
      else msg = el.dataset.on ? el.dataset.on.replace('{d}', shortDate(ship)) : el.dataset.monday;
      var span = el.querySelector('.u4y-deliv__ship-text');
      if (span) span.textContent = msg || '';
      el.hidden = !msg;
    });
    document.querySelectorAll('[data-u4y-eta]').forEach(function (el) {
      var tpl = el.getAttribute('data-u4y-eta') || '';
      el.textContent = tpl ? tpl.replace('{d}', shortDate(deliv)) : '';
      el.hidden = !tpl;
    });
  }
  function onVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.html || !data.sectionId) return;
    var id = 'u4y-deliv-' + data.sectionId;
    var fresh = data.html.getElementById ? data.html.getElementById(id) : data.html.querySelector('#' + id);
    var old = document.getElementById(id);
    if (fresh && old) {
      old.replaceWith(fresh.cloneNode(true));
      shipText();
    }
    setTimeout(fillBar, 50);
  }
  function bindVariantChange() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
      return true;
    }
    return false;
  }

  /* ---------------- 3. Farbvarianten kompakt ---------------- */
  var SWATCH_MAX = 7;
  function compactSwatches() {
    document.querySelectorAll('.product__info-container .mpg-swatch__nav').forEach(function (nav) {
      if (nav.dataset.u4ySw) return;
      var opts = Array.prototype.filter.call(nav.children, function (o) {
        return o.classList.contains('mpg-swatch__option');
      });
      if (!opts.length) return;
      nav.dataset.u4ySw = '1';
      if (opts.length <= SWATCH_MAX + 1) return;
      var sel = -1;
      opts.forEach(function (o, i) {
        if (/(^|\s|-|_)(selected|active|current)(\s|$)/.test(o.className) || o.getAttribute('aria-checked') === 'true' || o.getAttribute('aria-current') === 'true') sel = i;
      });
      var hidden = 0;
      opts.forEach(function (o, i) {
        var keep = i < SWATCH_MAX || i === sel;
        if (sel >= SWATCH_MAX && i === SWATCH_MAX - 1) keep = false;
        if (!keep) {
          o.classList.add('u4y-sw-extra');
          hidden++;
        }
      });
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'u4y-sw-more';
      var moreLabel = '+' + hidden + ' ' + (T.more || '');
      more.textContent = moreLabel;
      more.setAttribute('aria-expanded', 'false');
      more.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = nav.classList.toggle('u4y-sw-open');
        more.textContent = open ? T.less || '−' : moreLabel;
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      nav.appendChild(more);
    });
  }

  /* ---------------- 4. Fragen zum Produkt: Texte ---------------- */
  var UNITS = { second: 'second', minute: 'minute', hour: 'hour', day: 'day', week: 'week', month: 'month', year: 'year' };
  function relDate(text) {
    var m = /^\s*(a|an|one|\d+)\s+(second|minute|hour|day|week|month|year)s?\s+ago\s*$/i.exec(text);
    if (!m || typeof Intl === 'undefined' || !Intl.RelativeTimeFormat) return null;
    var n = /^\d+$/.test(m[1]) ? parseInt(m[1], 10) : 1;
    try {
      return new Intl.RelativeTimeFormat(LANG, { numeric: 'auto' }).format(-n, UNITS[m[2].toLowerCase()]);
    } catch (err) {
      return null;
    }
  }
  function setText(el, value) {
    if (value && el.textContent !== value) el.textContent = value;
  }
  function fixQA() {
    if (LANG === 'en') return;
    document.querySelectorAll('.prorw-review__question_widget_replied_text').forEach(function (b) {
      if (T.replied && /replied/i.test(b.textContent)) setText(b, b.textContent.replace(/replied\s*:?/i, T.replied));
    });
    document.querySelectorAll('[class*="prorw"] .created-date, .prorw-review__question-created-date').forEach(function (d) {
      var r = relDate(d.textContent);
      if (r) setText(d, r);
    });
    if (!T.answers) return;
    document.querySelectorAll('[class*="prorw"]').forEach(function (e) {
      Array.prototype.forEach.call(e.childNodes, function (n) {
        if (n.nodeType === 3 && /^\s*Answers?\s*$/.test(n.textContent)) n.textContent = ' ' + T.answers;
      });
    });
  }

  /* ---------------- 5. Geschenkverpackung kostenlos ---------------- */
  function fixUpsell() {
    document.querySelectorAll('.upsell-addon__price').forEach(function (p) {
      if (p.dataset.u4yFree) return;
      var first = p.firstChild;
      if (!first || first.nodeType !== 3) return;
      if (/^\s*\+?\s*0[.,]00\s*\D*\s*$/.test(first.textContent) || /^\s*\+?\s*\D{0,3}\s*0[.,]00\s*$/.test(first.textContent)) {
        first.textContent = T.free || first.textContent;
        p.dataset.u4yFree = '1';
        p.classList.add('upsell-addon__price--free');
      }
    });
  }

  /* ---------------- 6. Kaufleiste ---------------- */
  var bar = null;
  var mainBtn = null;
  var barWanted = false;
  function priceText() {
    var info = document.querySelector('.product__info-container');
    if (!info) return '';
    var price = info.querySelector('.price');
    if (!price) return '';
    var el = price.classList.contains('price--on-sale')
      ? price.querySelector('.price__sale .price-item--sale')
      : price.querySelector('.price__regular .price-item--regular');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function fillBar() {
    if (!bar || !mainBtn) return;
    var title = document.querySelector('.product__info-container .product__title h1, .product__info-container h1');
    var img = document.querySelector('media-gallery .product__media img');
    bar.querySelector('.u4y-buybar__title').textContent = title ? title.textContent.trim() : '';
    bar.querySelector('.u4y-buybar__price').textContent = priceText();
    var bImg = bar.querySelector('.u4y-buybar__img');
    if (img && (img.currentSrc || img.src)) {
      bImg.src = img.currentSrc || img.src;
      bImg.hidden = false;
    } else {
      bImg.hidden = true;
    }
    var label = mainBtn.querySelector('span') ? mainBtn.querySelector('span').childNodes[0] : null;
    bar.querySelector('.u4y-buybar__btn-label').textContent = (label && label.textContent.trim()) || mainBtn.textContent.trim();
    updateBar();
  }
  function updateBar() {
    if (!bar || !mainBtn) return;
    var show = barWanted && !mainBtn.disabled && !mainBtn.hasAttribute('disabled');
    bar.classList.toggle('is-visible', show);
    document.body.classList.toggle('u4y-buybar-on', show);
  }
  function buildBar() {
    mainBtn = document.querySelector('.product__info-container product-form .product-form__submit[name="add"]');
    if (!mainBtn || bar || !('IntersectionObserver' in window)) return;
    bar = document.createElement('div');
    bar.className = 'u4y-buybar';
    bar.innerHTML =
      '<div class="page-width u4y-buybar__inner">' +
      '<img class="u4y-buybar__img" alt="" width="48" height="48" hidden>' +
      '<div class="u4y-buybar__info"><span class="u4y-buybar__title"></span><span class="u4y-buybar__price"></span></div>' +
      '<button type="button" class="button button--primary u4y-buybar__btn"><span class="u4y-buybar__btn-label"></span>' +
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 7h12l-1 13H7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>' +
      '</button></div>';
    document.body.appendChild(bar);
    bar.querySelector('.u4y-buybar__btn').addEventListener('click', function () {
      if (mainBtn && !mainBtn.disabled) mainBtn.click();
    });
    /* Handy: Leiste immer, solange der echte Button nicht im Bild ist (auch vor dem Button, Usability v1 31.10.2026);
       Desktop: erst nachdem man am Button vorbeigescrollt ist */
    var mobileQ = window.matchMedia('(max-width: 749px)');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        barWanted = !en.isIntersecting && (mobileQ.matches || en.boundingClientRect.top < 0);
        updateBar();
      });
    }).observe(mainBtn);
    new MutationObserver(function () {
      fillBar();
    }).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
    fillBar();
  }

  /* ---------------- Start ---------------- */
  var queued = false;
  function runAll() {
    bindThumbSync();
    compactSwatches();
    fixQA();
    fixUpsell();
  }
  function start() {
    shipText();
    runAll();
    buildBar();
    if (!bindVariantChange()) {
      window.addEventListener('load', bindVariantChange, { once: true });
    }
    var main = document.querySelector('main') || document.body;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        runAll();
      }, 250);
    }).observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();